import React, { Component as C } from "react"
import PerfectScrollbar from "perfect-scrollbar"
import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
import { selectionTypes } from "@cirrus/legacy/app-common/enums/selection-types.es6"
import StatelessCheckbox from "@cirrus/legacy/app-components/form-controls/checkboxes/stateless-checkbox/index.jsx"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./items.less"

class TableFilterItems extends C {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    itemIcon: PropTypes.string,
    onItemValueChanged: PropTypes.func,
    hideEmptyHint: PropTypes.bool,
    onDeleteItem: PropTypes.func,
    noItemsAvailableText: PropTypes.string,
    dataQa: PropTypes.string,
  }

  perfectScrollbar = null

  constructor(props) {
    super(props)

    this._setItemsList = this.setItemsList.bind(this)
  }

  componentDidMount() {
    if (this._itemsList == null) {
      return
    }

    this.perfectScrollbar = new PerfectScrollbar(this._itemsList, this.getScrollbarOptions())
  }

  componentDidUpdate() {
    if (this._itemsList == null) {
      return
    }

    if (this.perfectScrollbar) {
      this.perfectScrollbar.update()
    } else {
      this.perfectScrollbar = new PerfectScrollbar(this._itemsList, this.getScrollbarOptions())
    }
  }

  componentWillUnmount() {
    if (this.perfectScrollbar && this._itemsList != null) {
      this.perfectScrollbar.destroy()
    }

    this.perfectScrollbar = null
  }

  getScrollbarOptions() {
    return {
      wheelPropagation: false,
    }
  }

  setItemsList(element) {
    if (this.perfectScrollbar && this._itemsList != null) {
      this.perfectScrollbar.destroy()
    }

    this.perfectScrollbar = null
    this._itemsList = element
  }

  render() {
    let { items, onItemValueChanged, hideEmptyHint, dataQa, itemIcon, noItemsAvailableText } =
      this.props

    return (
      <div ref={this._setItemsList} className={classnames(styles.tableList, this.props.className)}>
        <div data-qa={dataQa}>
          {!!items.length &&
            items.map((i, index) => {
              return (
                <div key={i.id} className={styles.listItem}>
                  {i.selectedType !== undefined ? (
                    <StatelessCheckbox
                      onChange={(isChecked) => onItemValueChanged(isChecked, i.id, i.selectedType)}
                      isChecked={
                        i.selectedType === selectionTypes.selected ||
                        i.selectedType === selectionTypes.indeterminate
                      }
                      className={classnames(
                        styles.tableListItem,
                        i.selectedType === selectionTypes.indeterminate
                          ? styles.indeterminate
                          : null,
                      )}>
                      <div className={styles.labelWrap}>
                        {itemIcon && (
                          <Icon style={{ fontSize: "24px", margin: "0 5px" }} icon={itemIcon} />
                        )}
                        {i.title}
                      </div>
                    </StatelessCheckbox>
                  ) : (
                    <StatelessCheckbox
                      onChange={(isChecked) => onItemValueChanged(isChecked, i.id)}
                      isChecked={i.isSelected}
                      className={styles.tableListItem}>
                      <div className={styles.labelWrap}>
                        {itemIcon && (
                          <Icon style={{ fontSize: "24px", margin: "0 5px" }} icon={itemIcon} />
                        )}
                        {i.title}
                      </div>
                    </StatelessCheckbox>
                  )}
                </div>
              )
            })}
          {this.props.children}
          {!items.length && !hideEmptyHint && (
            <span className={styles.empty}>{i18n(noItemsAvailableText)}</span>
          )}
        </div>
      </div>
    )
  }
}

export default TableFilterItems
